import React, { Component } from 'react';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-balham.css';
import './ag-theme-ela.css';
import RemoveIcon from '../images/remove-icon.png';

const DEFAULT_MIN_WIDTH_CELL = 10;
const DEFAULT_MAX_WIDTH_CELL = 800;

const defaultColDef = {
  resizable: true,
  sortable: true,
  filter: true,
  minWidth: DEFAULT_MIN_WIDTH_CELL,
  maxWidth: DEFAULT_MAX_WIDTH_CELL,
  cellStyle: {
    borderRight: '1px solid #ccc',
  },
};

const repColumns = [
  {
    headerName: '',
    field: 'delete',
    width: 30,
    cellRenderer: 'deleteButtonCellRenderer',
    resizable: true,
  },
  {
    headerName: 'Rep Name',
    field: 'repName',
    width: 150,
    valueGetter: (params) =>
      `${params.data.repLastName}, ${params.data.repFirstName} (${params.data.clientAbbrv})`,
    resizable: true,
  },
  { headerName: 'Phone', field: 'repPhone', width: 150, resizable: true },
  { headerName: 'Email', field: 'repEmail', width: 200, resizable: true },
  { headerName: 'Client', field: 'clientName', width: 200, resizable: true },
  { headerName: 'Notes', field: 'repNote', width: 600, resizable: true },
];

export class ClientTableReps extends Component {
  constructor(props) {
    super(props);
    this.gridApi = null;
    this.gridColumnApi = null;

    this.onGridReady = this.onGridReady.bind(this);
    this.adjustHeaderHeight = this.adjustHeaderHeight.bind(this);
    this.autoSizeUnspecifiedColumns =
      this.autoSizeUnspecifiedColumns.bind(this);
  }

  onGridReady = (params) => {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.adjustHeaderHeight(params.api);
    this.autoSizeUnspecifiedColumns();
  };

  adjustHeaderHeight = (gridApi) => {
    window.requestAnimationFrame(() => {
      const allColumnHeaders = document.querySelectorAll(
        '.ag-header-cell-text'
      );
      let maxHeight = 0;
      allColumnHeaders.forEach((header) => {
        if (header.parentElement.clientHeight > maxHeight) {
          maxHeight = header.parentElement.clientHeight;
        }
      });
      maxHeight += 10;
      gridApi.setHeaderHeight(maxHeight);
    });
  };

  autoSizeUnspecifiedColumns = () => {
    if (!this.gridColumnApi) return;
    const allColumnIds = [];
    this.gridColumnApi.getColumns().forEach((column) => {
      if (column.getColDef().width === undefined) {
        allColumnIds.push(column.colId);
      }
    });
    if (allColumnIds.length > 0) {
      this.gridColumnApi.autoSizeColumns(allColumnIds, false);
    }
  };

  render() {
    const gridOptions = {
      suppressSizeToFit: true,
      columnDefs: repColumns,
      rowData: this.props.reps,
      context: {
        componentParent: this,
        gridApi: this.gridApi,
        setModal: this.props.setModal,
        state: this.props.state,
      },
      animateRows: true,
      defaultColDef: defaultColDef,
      componentsw: {
        deleteButtonCellRenderer: DeleteButtonCellRenderer,
      },
      onColumnResized: this.props.onColumnResized,
      rowHeight: 20,
      tooltipShowDelay: 0,
      enableBrowserTooltips: true,
      onRowDoubleClicked: this.props.handleDoubleClickRep,
    };

    return (
      <div
        className="ag-theme-balham"
        style={{
          width: '100%',
          height: '300px',
        }}
      >
        <AgGridReact {...gridOptions} onGridReady={this.onGridReady} />
      </div>
    );
  }
}

class DeleteButtonCellRenderer extends React.Component {
  handleDelete = () => {
    const data = this.props.data; // Data for the row
    if (window.confirm('Are you sure to delete this record?')) {
      this.props.context.componentParent.handleDeleteRep(data);
    }
  };

  render() {
    return (
      <img
        src={RemoveIcon}
        style={{ width: '16px', cursor: 'pointer' }}
        onClick={this.handleDelete}
        alt="Delete"
      />
    );
  }
}
